import { render, staticRenderFns } from "./OrgsList.vue?vue&type=template&id=89aa1644&"
import script from "./OrgsList.vue?vue&type=script&lang=js&"
export * from "./OrgsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports